import { GTrack } from 'core';
import { defineStore } from 'pinia';
import { TrackParms } from 'types';

export const useTrackStore = defineStore('trackShow', {
  state: () => ({
    trackList: [] as TrackParms[],
  }),
  actions: {
    addTrack(track: TrackParms) {
      GTrack.sw(track);
      this.trackList.push(track);
    },
    clearTrack() {
      this.trackList = [];
    },
    removeTrackById(id: string) {
      this.trackList = this.trackList.filter((item) => item.id !== id);
    },
  },
});
